export interface ZoomDisabled {
  inDisabled: boolean;
  outDisabled: boolean;
}

/** A small tolerance so float drift near the limits still reads as "at bound". */
const EPSILON = 0.001;

export function zoomDisabledState(zoom: number, min: number, max: number): ZoomDisabled {
  return {
    inDisabled: zoom >= max - EPSILON,
    outDisabled: zoom <= min + EPSILON,
  };
}
